import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import Information from "../../components/information/component";
import {industriesRegister} from "../../services/industriesRegister";
import AnimateHeight from "react-animate-height";

class SignupIndustry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            industries: [],
            industry: null,
            new_grid: {}
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/signup-industry');
        }
        
    }

    componentDidMount(){
        this.industry.update();
    }

    industry = {
        update: () => {
            this.setState({isLoading: true}, () => {
                if (industriesRegister.get()) {
                    this.setState({industries: industriesRegister.get()}, () => {
                        this.industry.grid(this.state.industries);
                    });
                } else {
                    dataRegister.getIndustries(salesChannelRegister.get("market"), langRegister.lang()).then((response) => {
                        if (!response.errors) {
                            this.setState({industries: response}, () => {
                                this.industry.grid(this.state.industries);
                            });
                        }
                    }, (error) => {
                        this.setState({error: true, isLoading: false}, () => {
                            console.log(error);
                        });
                    });
                }
            });
        },
        check: (object) => {
            let storage = cartRegister.get();
            this.setState({industry: storage.industry}, () => {
                try {
                    if(this.state.industry){
                        object[this.state.industry.group].height = "auto";
                        object[this.state.industry.group].industries[this.state.industry.name].selected = true;
                        this.setState({isLoading: false, new_grid: this.functions.chunkArray(object, 5)});
                    }else{
                        this.setState({isLoading: false, industry: null, new_grid: this.functions.chunkArray(object, 5)});
                    }
                } catch (error) {
                    this.setState({isLoading: false, industry: null, new_grid: this.functions.chunkArray(object, 5)});
                }
            })
        },
        grid: (industries) => {
            //SORT BY ALPHABETICALY
            industries = industries.sort(function (a, b) {
                if (a.group < b.group) {
                    return -1;
                }
                if (a.group > b.group) {
                    return 1;
                }
                return 0;
            });
            industries.sort(function (a, b) {
                if (a.owned_by < b.owned_by) {
                    return 1;
                }
                if (a.owned_by > b.owned_by) {
                    return -1;
                }
                return 0;
            });
            let object = {};
            for (let i = 0; i < industries.length; i++) {
                if (object[industries[i].group]) {
                    object[industries[i].group].industries[industries[i].name] = industries[i]
                } else {
                    object[industries[i].group] = {industries: {}, selected: false, height: 0, owned: (industries[i].owned_by || industries[i].saleschannel_owner)};
                    object[industries[i].group].industries[industries[i].name] = industries[i]
                }
            }
            this.industry.check(object);
        },
        select: (item) => {
            cartRegister.setIndustry(item);
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/signup/crossroad");

        }
    };

    functions = {
        chunkArray: (object, chunk_size) => {
            var index = 0;
            var index_object = 0;
            var tempArray = {};
            tempArray[index_object] = {};
            for (var key in object) {
                if (index < chunk_size) {
                    tempArray[index_object][key] = object[key];
                    index++;
                } else {
                    index_object++;
                    tempArray[index_object] = {};
                    tempArray[index_object][key] = object[key];
                    index = 0;
                }
            }
            return tempArray;
        }
    };

    parse = {
        text: (item) => {
            return langRegister.get("signup-industry", item);
        }
    };

    render() {
        return (
            <div>
                <HeaderSignupOne view={"signup"} props={this.props}/>
                {
                    !this.state.error && !this.state.isLoading &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this.parse.text("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            {
                                Object.keys(this.state.new_grid).map((key, i) => {
                                    return (
                                        <div key={key}>
                                            {
                                                Object.keys(this.state.new_grid[key]).map((key_two, i) => {
                                                    return (
                                                        <div key={key_two}>
                                                            {
                                                                <div onClick={() => {
                                                                    this.state.new_grid[key][key_two].height = this.state.new_grid[key][key_two].height === "auto" ? 0 : "auto";
                                                                    this.setState({new_grid: this.state.new_grid})
                                                                }}
                                                                     className={cx(Styles.optionsContainerTitle)}>
                                                                    <div className={Styles.optionsContainerTitleText}>
                                                                        <div
                                                                            className={Styles.optionsContainerTitleTextInner}>
                                                            <span className={
                                                                cx(Styles.subTitleSmallHeaderTop,
                                                                    {
                                                                        [Styles.subTitleSmallHeaderTopGreen]: this.state.new_grid[key][key_two].owned,
                                                                    })
                                                            }>
                                                                {key_two} <span className={Styles.subTitleSmallHeaderTopFat}>({Object.keys(this.state.new_grid[key][key_two].industries).length})</span>
                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        !this.state.new_grid[key][key_two].selected &&
                                                                        <div
                                                                            className={Styles.optionsContainerTitleSelector}>
                                                                            {
                                                                                this.state.new_grid[key][key_two].height === "auto" &&
                                                                                <span>–</span>
                                                                            }
                                                                            {
                                                                                this.state.new_grid[key][key_two].height !== "auto" &&
                                                                                <span>+</span>
                                                                            }
                                                                        </div>

                                                                    }
                                                                </div>
                                                            }
                                                            {
                                                                <AnimateHeight
                                                                    duration={100}
                                                                    height={this.state.new_grid[key][key_two].height}
                                                                >
                                                                    <div className={Styles.optionsContainerChildren}>
                                                                        {
                                                                            Object.keys(this.state.new_grid[key][key_two].industries).map((key_three) => {
                                                                                return (
                                                                                    <div key={key_three} onClick={() => this.industry.select(this.state.new_grid[key][key_two].industries[key_three])}
                                                                                         className={Styles.optionsContainerChildrenItem}>
                                                                                        {
                                                                                            !this.state.new_grid[key][key_two].industries[key_three].selected &&
                                                                                            <img
                                                                                                src={require("../../assets/images/checkmark_new.svg")}
                                                                                                className={Styles.optionsContainerChildrenItemIcon}/>
                                                                                        }
                                                                                        {
                                                                                            this.state.new_grid[key][key_two].industries[key_three].selected &&
                                                                                            <img
                                                                                                src={require("../../assets/images/square_checkmark_active.svg")}
                                                                                                className={Styles.optionsContainerChildrenItemIcon}/>
                                                                                        }
                                                                                        <div
                                                                                            className={Styles.optionsContainerChildrenItemText}>
                                                                                            {this.state.new_grid[key][key_two].industries[key_three].name}
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                    {
                                                                        <div className={Styles.optionsContainerChildrenDivider}/>
                                                                    }
                                                                </AnimateHeight>
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default SignupIndustry;


// WEBPACK FOOTER //
// ./src/pages/signup-industry/component.js